<template>
    <div id="home">
        <Loading  :loadingHide="loadingHide"></Loading>
        <Header></Header>
        <div class="carouselBox">
            <el-carousel v-if="carouselList.length" :interval="5000">
                <el-carousel-item 
                 :class="item.content? 'curp' : ''" 
                  v-for="(item, index) in carouselList" 
                  :key="index"
                  @click.native="handleCarousel(item)">
                    <img :src="item.pic" alt="">
                    <span v-if="item.content" class="characteristic">点击查看详情</span>
                </el-carousel-item>
            </el-carousel>
        </div>
        <section id="team">
            <div class="container" v-if="choicenessCardList.length">
                <div class="title text-center">
                    <h3 class="title-text">精选作品</h3>
                    <p class="lead">Selected works</p>
                </div>
                <div class="row">
                    <div 
                     class="col-sm-6 col-md-3"
                     v-for="(item, index) in choicenessCardList"
                     :key="index"
                    >
                        <div class="team_member">
                            <div class="entry" @click="goContentPage(item.id)">
                                <img class="img-responsive" :src="item.cover">
                            </div>
                            <div class="lawyer">
                                <h3>{{ item.name }}</h3>
                                <div class="lawyer-details">
                                    <div class="user-panel border-top">
                                        <img @click="goUserHome(item.authorId)" :src="item.authorAvatar?item.authorAvatar :''" class="user-headimg" />
                                        <span @click="goUserHome(item.authorId)">{{item.authorName? item.authorName : ''}}</span>
                                    </div>
                                    <div class="user-panel">
                                        <ul class="user-eyes">
                                            <li class="likes">
                                                <svg-icon class="like"  @click="giveLike(3, item, index)" :icon-class="item.zansStatus? 'zan-active' : 'zan' "/>{{item.likeNum}}
                                                <!-- <span :class="item.zansStatus? 'like likeOk' : 'like'" @click="giveLike(3, item, index)"></span>{{item.likeNum}} -->
                                            </li>
                                            <li class="eyes"><i class="el-icon-view"></i>{{item.visNum}}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="choicenessCardList.length >= 8">
                    <div class="col-md-12 text-center see_more_button">
                        <router-link :to="{name:'works', params:{ sort: 'topDate' }}" class="attorney-button">查看更多</router-link>
                    </div>
                </div>
            </div>
            <div class="container">
                <div class="title text-center">
                    <h3 class="title-text">最热作品</h3>
                    <p class="lead">Hot works</p>
                </div>
                <div class="row">
                    <div 
                     class="col-sm-6 col-md-3"
                     v-for="(item, index) in hotCardList"
                     :key="index"
                    >
                        <div class="team_member">
                            <div class="entry" @click="goContentPage(item.id)">
                                <img class="img-responsive" :src="item.cover">
                            </div>
                            <div class="lawyer">
                                <h3>{{ item.name }}</h3>
                                <div class="lawyer-details">
                                    <div class="user-panel border-top">
                                        <img @click="goUserHome(item.authorId)" :src="item.authorAvatar?item.authorAvatar :''" class="user-headimg" />
                                        <span @click="goUserHome(item.authorId)">{{item.authorName? item.authorName : ''}}</span>
                                    </div>
                                    <div class="user-panel">
                                        <ul class="user-eyes">
                                            <li class="likes">
                                                <svg-icon class="like"  @click="giveLike(1, item, index)" :icon-class="item.zansStatus? 'zan-active' : 'zan' "/>{{item.likeNum}}
                                                <!-- <span :class="item.zansStatus? 'like likeOk' : 'like'" @click="giveLike(1, item, index)"></span>{{item.likeNum}} -->
                                            </li>
                                            <li class="eyes"><i class="el-icon-view"></i>{{item.visNum}}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 text-center see_more_button">
                        <router-link :to="{name:'works', params:{ sort: 'visNum' }}" class="attorney-button">查看更多</router-link>
                    </div>
                </div>
            </div>
            <div class="container">
                <div class="title text-center">
                    <h3 class="title-text">最新作品</h3>
                    <p class="lead">The latest work</p>
                </div>

                <div class="row">
                    <div 
                     class="col-sm-6 col-md-3"
                     v-for="(item, index) in createCardList"
                     :key="index"
                    >
                        <div class="team_member">
                            <div class="entry" @click="goContentPage(item.id)">
                                <img class="img-responsive" :src="item.cover" alt="">
                            </div>
                            <div class="lawyer">
                                <h3>{{ item.name }}</h3>
                                <div class="lawyer-details">
                                    <div class="user-panel border-top">
                                        <img @click="goUserHome(item.authorId)" :src="item.authorAvatar?item.authorAvatar :''" class="user-headimg" />
                                        <span @click="goUserHome(item.authorId)">{{item.authorName? item.authorName : ''}}</span>
                                    </div>
                                    <div class="user-panel">
                                        <ul class="user-eyes">
                                            <li class="likes">
                                                <svg-icon class="like"  @click="giveLike(2, item, index)" :icon-class="item.zansStatus? 'zan-active' : 'zan' "/>{{item.likeNum}}
                                                <!-- <span :class="item.zansStatus? 'like likeOk' : 'like'" @click="giveLike(2, item, index)"></span>{{item.likeNum}} -->
                                            </li>
                                            <li class="eyes"><i class="el-icon-view"></i>{{item.visNum}}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 text-center see_more_button">
                        <router-link :to="{name:'works', params:{ sort: 'createDate' }}"  class="attorney-button">查看更多</router-link>
                    </div>
                </div>
            </div>
        </section>
        <Foot></Foot>
    </div>
</template>

<script>
import Loading from '@/components/loading';
import Header from "@/components/header";
import Foot from "@/components/foot";
import communityApi from "@/request/api/community";
import institutionApi from '@/request/api/institution';

export default {
    computed: {
        institutionId() {
            return this.$store.state.institutionId;
        }
    },
    components: {
        Loading,
        Header,
        Foot
    },
    name: 'home',
    data () {
        return {
            choicenessCardList: [], //精选作品列表
            hotCardList: [], //最热作品列表
            createCardList: [], //最新作品列表
            carouselList: [], //轮播图列表
            carouselState: false,
            worksListVisState: false,
            worksListCreateDateState: false,
            worksListChoiceness: false,
            loadingHide: false,
        }
    },
    watch: {
        carouselState() {
            if(this.carouselState && this.worksListVisState && this.worksListCreateDateState && this.worksListChoiceness) {
                this.loadingHide = true;
            }
        },
        worksListVisState() {
            if(this.carouselState && this.worksListVisState && this.worksListCreateDateState && this.worksListChoiceness) {
                this.loadingHide = true;
            }
        },
        worksListCreateDateState() {
            if(this.carouselState && this.worksListVisState && this.worksListCreateDateState && this.worksListChoiceness) {
                this.loadingHide = true;
            }
        },
        worksListChoiceness() {
            if(this.carouselState && this.worksListVisState && this.worksListCreateDateState && this.worksListChoiceness) {
                this.loadingHide = true;
            }
        },
    },
    created() {
        this.getCarousel();
        this.getWorksList();
    },
    methods: {
        //获取轮播图
        getCarousel() {
            let params = {
                "institutionId": this.institutionId,
                "pageNumber": 0,
                "pageSize": 999,
                "sortDirection": 0,
                "sortName": "1",
                "status": "展示",
                "type": "轮播图"
            };
            institutionApi.institutionNoticeList(params, res => {
                if(res.succeed) {
                    this.carouselList = res.data.content? res.data.content : [];
                }
                this.carouselState = true;
            })
        },
        //请求首页数据
        getWorksList() {
            let params1 = {
                type: 'visNum',
                institutionId: this.institutionId
            };
            communityApi.worksList(params1, res => {
                if(res.succeed) {
                    this.hotCardList = res.data? res.data : [];
                }
                this.worksListVisState = true;
            })
            let params2 = {
                type: 'createDate',
                institutionId: this.institutionId
            };
            communityApi.worksList(params2, res => {
                if(res.succeed) {
                    this.createCardList = res.data? res.data : [];
                }
                this.worksListCreateDateState = true;
            })
            let params3 = {
                type: 'topDate',
                institutionId: this.institutionId
            }
            communityApi.worksList(params3, res => {
                if(res.succeed) {
                    this.choicenessCardList = res.data? res.data : [];
                }
                this.worksListChoiceness = true;
            })
        },
        goContentPage(id) {
            this.$router.push({path: `workcontent/${id}`});
            // let url = this.$router.resolve({path: `workcontent/${id}`});
            // window.open(url.href, "_blank")
        },
        //查看卡片用户
        goUserHome(id) {
            this.$router.push({ name: "personhome", query: { id }});
        },
        //点击轮播图
        handleCarousel(item) {
            if(item.content) {
                this.$router.push({ 
                    name: 'notification', 
                    params: { 
                        'title': item.name? item.name : '', 
                        'content': item.content? item.content : '' 
                    }
                })
            }
        },
        //点赞
        giveLike(type, item, index) {
            if(this.$store.state.loginBtnShow) {
                this.$store.commit('setDialogVisible', true);
            } else {
                if(item.zansStatus) {
                    communityApi.cancelLikeWorks(item.id, res => {
                        if(res.succeed) {
                            if(type == 1) {
                                this.$set(this.hotCardList[index], "zansStatus", false);
                                this.$set(this.hotCardList[index], "likeNum", this.hotCardList[index].likeNum - 1);
                            } else if(type == 2) {
                                this.$set(this.createCardList[index], "zansStatus", false);
                                this.$set(this.createCardList[index], "likeNum", this.createCardList[index].likeNum - 1);
                            } else if(type == 3) {
                                this.$set(this.choicenessCardList[index], "zansStatus", false);
                                this.$set(this.choicenessCardList[index], "likeNum", this.choicenessCardList[index].likeNum - 1);
                            }
                        }
                    })
                } else {
                    communityApi.likeWords(item.id, res => {
                        if(res.succeed) {
                            if(type == 1) {
                                this.$set(this.hotCardList[index], "zansStatus", true);
                                this.$set(this.hotCardList[index], "likeNum", this.hotCardList[index].likeNum + 1);
                            } else if(type == 2) {
                                this.$set(this.createCardList[index], "zansStatus", true);
                                this.$set(this.createCardList[index], "likeNum", this.createCardList[index].likeNum + 1);
                            } else if(type == 3) {
                                this.$set(this.choicenessCardList[index], "zansStatus", true);
                                this.$set(this.choicenessCardList[index], "likeNum", this.choicenessCardList[index].likeNum + 1);
                            }
                        }
                    })
                }
            }
        },
    }
}
</script>

<style lang="scss">
#home {
    .curp {
        cursor: pointer;
    }
    .carouselBox {
        position: relative;
    }
    .characteristic {
        position: absolute;
        right: 5px;
        bottom: 5px;
        padding: 2px 5px;
        color: #fff;
        font-size: 12px;
        background: rgba(0, 0, 0, 0.1);
    }
    .el-carousel__container {
        height: calc(100vw/16*3);
    }
    .el-carousel__item img {
        width: 100%;
    }
    .lawyer,
    .attorney-button {
        background-color: var(--theme-color);
    }
    .lawyer .pf_button {
        cursor: pointer;
    }
    .lawyer .pf_button:hover {
        color: var(--theme-color);
    }
    .attorney-button:hover, .attorney-button:focus {
        color: var(--theme-color);
        background-color: #fff;
        border: 1px solid var(--theme-color);
    }
    .user-panel {
        overflow: hidden;
    }
    .user-panel li {
        position: relative;
        display: inline-block;
        font-size: 15px;
    }
    .user-eyes {
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        margin-bottom: 0;
    }
    .user-eyes li:nth-child(1) {
        margin-right: 10px;
    }
    .user-eyes i {
        margin-right: 5px;
    }
    .user-eyes .like {
        // padding: 8px;
        // margin-right: 5px;
        // background-image: url("../../assets/zan.png");
        // background-repeat: no-repeat;
        // background-position: center center;
        // background-size: contain;
        cursor: pointer;
    }
    .user-eyes .likeOk {
        background-image: url("../../assets/zan2.png");
    }
    .user-panel.border-top {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-start;
        align-items: center;
        width: 45%;
    }
    .user-headimg {
        width: 25px;
        height: 25px;
        border-radius: 50%;
        margin-right: 4px;
        cursor: pointer;
    }
    .user-panel.border-top span {
        font-size: 13px;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
        overflow: hidden;
    }
    @media (max-width: 767px){
        .el-carousel__indicators--horizontal {
            display: none !important;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/home/home.vue